"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateValidationSchema = exports.generateFieldSchema = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _zod = require("zod");
var _TranslationKey = require("../models/TranslationKey");
const generateFieldSchema = (fieldConfig, formatMessage) => {
  const {
    maxLength,
    minLength,
    isMandatory,
    regularExpression
  } = fieldConfig.validation;
  let fieldSchema = _zod.z.string();
  if (!fieldConfig.validation) {
    return fieldSchema.nullable();
  }
  if (isMandatory) {
    fieldSchema = fieldSchema.min(1, formatMessage(_TranslationKey.TranslationKey.validationRequired));
  }
  if (minLength !== null && typeof minLength === 'number') {
    fieldSchema = fieldSchema.min(minLength, formatMessage(_TranslationKey.TranslationKey.validationMinLength, {
      min: minLength
    }));
  }
  if (maxLength !== null && typeof maxLength === 'number') {
    fieldSchema = fieldSchema.max(maxLength, formatMessage(_TranslationKey.TranslationKey.validationMaxLength, {
      max: maxLength
    }));
  }
  if (regularExpression) {
    fieldSchema = fieldSchema.regex(new RegExp(regularExpression), formatMessage(_TranslationKey.TranslationKey.validationRegex));
  }
  return fieldSchema.nullable();
};
exports.generateFieldSchema = generateFieldSchema;
const generateValidationSchema = (config, formatMessage) => {
  const addressTypeSchema = _zod.z.enum(Object.values(_globalApiClientReact.GlobalSharedAddressDtoAddressType));
  return _zod.z.object({
    city: generateFieldSchema(config.city ?? {}, formatMessage),
    streetAddress: generateFieldSchema(config.streetAddress ?? {}, formatMessage),
    zipcode: generateFieldSchema(config.zipcode ?? {}, formatMessage),
    province: generateFieldSchema(config.province ?? {}, formatMessage),
    delivery: generateFieldSchema(config.delivery ?? {}, formatMessage),
    delivery2: generateFieldSchema(config.delivery2 ?? {}, formatMessage),
    delivery3: generateFieldSchema(config.delivery3 ?? {}, formatMessage),
    area: generateFieldSchema(config.area ?? {}, formatMessage),
    locality: generateFieldSchema(config.locality ?? {}, formatMessage),
    district: generateFieldSchema(config.district ?? {}, formatMessage),
    region: generateFieldSchema(config.region ?? {}, formatMessage),
    country: generateFieldSchema(config.country ?? {}, formatMessage),
    addressType: addressTypeSchema,
    isPrimary: _zod.z.boolean()
  });
};
exports.generateValidationSchema = generateValidationSchema;
//# sourceMappingURL=validationSchema.js.map